import "./auth.css";
import { yupResolver } from "@hookform/resolvers/yup";
import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useRef, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import "react-simple-keyboard/build/css/index.css";
import { ToastSuccess } from "../../Shared/Toasts/ToastSuccess";
import { ToastWarning } from "../../Shared/Toasts/ToastWarning";
import {
  loginApi,
  loginBadgeApi,
  selectIsLoggedIn,
} from "../../_App/Redux/Slices/Auth/authSlice";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";
import { LoginSchema } from "../../_App/Schemas/LoginSchema";
import { LoginDataType } from "../../_App/Types/Forms/LoginDataType";
import PasswordResetForm from "./PasswordInitialResetForm";
import NumericKeypad from "./PinKeyboard";
import { findUserByBarcode } from "../../_App/Redux/Slices/users/userSlice";
import AlphaNumericKeypad from "../../_App/Helpers/AlphaNumericKeypad";

interface LoginParCodeProps {
  setBadge: any;
  badge: any;
  setShowMacAddressPopup: any;
  showPinModal: any;
  setShowPinModal: any;
}

const LoginParCode: React.FC<LoginParCodeProps> = ({
  setBadge,
  badge,
  setShowMacAddressPopup,
  showPinModal,
  setShowPinModal,
}) => {
  const dispatch = useAppDispatch();
  const isLoggedIn = useAppSelector(selectIsLoggedIn);
  const [pin, setPin] = useState("");
  const [codebarre, setcodebarre] = useState("");
  const handlePinComplete = (input: string) => {
    setPin(input);
  };

  const [pinInput, setPinInput] = useState("");

  const navigate = useNavigate();

  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const lastKeyPressTime = useRef<number>(0);
  const fromVirtualKeyboard = useRef(false);

  const inputRef = useRef<HTMLInputElement>(null);
  const cursorIndexRef = useRef<number>(0);
  useEffect(() => {
    const now = Date.now();
    const timeDiff = now - lastKeyPressTime.current;
    lastKeyPressTime.current = now;

    let isScannerInput = timeDiff < 50 && !fromVirtualKeyboard.current;
    const delay = isScannerInput ? 100 : 2000;

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      if (codebarre.trim() !== "") {
        loginfunction(codebarre.trim());
      }
      // Reset the flag for virtual keyboard
      fromVirtualKeyboard.current = false;
    }, delay);
  }, [codebarre]);

  const loginfunction = async (value: any) => {
    const codemachine=localStorage.getItem("idmachine")
    const response = await dispatch(
      loginBadgeApi({
        pin: pin,
        code_a_barre: value,
        machineId:codemachine,
      })
    );

    if (response.payload.success) {
      if (response.payload.message === "Machine n'est pas enregistrer") {
        // affiche popup de   d'enregister la machine
        setShowMacAddressPopup(true);
      } else {
        ToastSuccess(response.payload.message);
        setShowPinModal(true);
      }
    } else {
      ToastWarning(response.payload.message);
    }
  };

  const clearPin = () => {
    setPinInput("");
  };
  const handleLayoutChange = () => {
    const inputElement = inputRef.current;
    if (inputElement) {
      setTimeout(() => {
        inputElement.focus();
        inputElement.setSelectionRange(
          cursorIndexRef.current,
          cursorIndexRef.current
        );
      }, 0);
    }
  };

  const handleKeyPress = (val: string) => {
    const inputElement = inputRef.current;
    if (!inputElement) return;

    // Re-focus input to keep cursor
    inputElement.focus();

    const cursorIndex = inputElement.selectionStart ?? cursorIndexRef.current;

    const newCodebarre =
      codebarre.slice(0, cursorIndex) + val + codebarre.slice(cursorIndex);

    setcodebarre(newCodebarre);
    fromVirtualKeyboard.current = true;

    cursorIndexRef.current = cursorIndex + 1;

    setTimeout(() => {
      inputElement.focus();
      inputElement.setSelectionRange(
        cursorIndexRef.current,
        cursorIndexRef.current
      );
    }, 0);
  };

  const handleDelete = () => {
    const inputElement = inputRef.current;
    if (!inputElement) return;

    inputElement.focus(); // 👈 Keep focus

    const cursorIndex = inputElement.selectionStart ?? cursorIndexRef.current;

    if (cursorIndex > 0) {
      const newCodebarre =
        codebarre.slice(0, cursorIndex - 1) + codebarre.slice(cursorIndex);

      setcodebarre(newCodebarre);
      cursorIndexRef.current = cursorIndex - 1;

      setTimeout(() => {
        inputElement.focus();
        inputElement.setSelectionRange(
          cursorIndexRef.current,
          cursorIndexRef.current
        );
      }, 0);
    }
  };

  return (
    <div className="form">
      <div className="form-container">
        <div className="form-form">
          <div className="form-form-wrap" style={{ paddingTop: "100px" }}>
            <div>
              <div className="form-content">
                <h1 className="">
                  <span> {"Login caisse "}</span>
                </h1>
                <div className="form">
                  <div id="username-field">
                    <input
                      ref={inputRef}
                      id="myInput"
                      className="form-control"
                      value={codebarre}
                      onChange={(e) => {
                        setcodebarre(e.target.value);
                        cursorIndexRef.current =
                          e.target.selectionStart ?? codebarre.length;
                      }}
                      onClick={(e) => {
                        cursorIndexRef.current =
                          (e.target as HTMLInputElement).selectionStart ??
                          codebarre.length;
                      }}
                      onKeyUp={(e) => {
                        cursorIndexRef.current =
                          inputRef.current?.selectionStart ?? codebarre.length;
                      }}
                      autoFocus
                      style={{ width: "100%" }}
                    />

                    <div>
                      {" "}
                      <AlphaNumericKeypad
                        onKeyPress={handleKeyPress}
                        onDelete={handleDelete}
                        onLayoutChange={handleLayoutChange} // 👈 NEW
                      />
                    </div>

                    <div className="pre-icon os-icon os-icon-user-male-circle"></div>
                  </div>
                </div>
                <p className="terms-conditions">
                  <span
                    className="pointer lien-bleu-souligne"
                    onClick={() =>
                      setBadge(badge === "Badge" ? "mail" : "Badge")
                    }
                  >
                    Login par email{" "}
                  </span>
                </p>
                <p className="terms-conditions">
                  © 2023 All Rights Reserved{" "}
                  <a href="https://www.nomadis.online">Clediss</a>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="form-image">
          <div className="l-image"></div>
        </div>
        <Modal
          show={showPinModal}
          onHide={() => setShowPinModal(false)}
          centered
        >
          <Modal.Header closeButton>
            <div className="header-message">
              Le code PIN a été envoyé par mail et SMSsss{" "}
            </div>
          </Modal.Header>
          <Modal.Body>
            <Row className="text-center mt-2">
              <Col className="mb-2">
                <NumericKeypad
                  onComplete={handlePinComplete}
                  email={""}
                  password={""}
                  code_a_barre={codebarre}
                  bagde={badge}
                />
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};

export default LoginParCode;
